import React from "react";
import { House, ChatCircleDots, CalendarCheck, Bell, UserCircle } from "@phosphor-icons/react";

const QUICK_ACTIONS = [
    { icon: ChatCircleDots, label: "Complaint" },
    { icon: CalendarCheck, label: "Amenity" },
    { icon: Bell, label: "Notices" },
    { icon: House, label: "My Flat" },
];

const TABS = [
    { icon: House, label: "Home", active: true },
    { icon: ChatCircleDots, label: "Requests" },
    { icon: CalendarCheck, label: "Amenities" },
    { icon: UserCircle, label: "Profile" },
];

/**
 * A realistic portrait-smartphone mockup (~9:19.5) showcasing the Maintayn Resident
 * app experience for the hero section — built from real UI/data (society name, dues,
 * quick actions, notices, bottom tab bar), not a shrunken desktop screenshot.
 */
export function HeroPhoneMockup({ className = "", width = 222 }) {
    const height = Math.round(width * (19.5 / 9));
    return (
        <div className={`relative ${className}`} style={{ width }} data-testid="hero-phone-mockup">
            <div
                className="relative bg-gradient-to-b from-[#2A2E33] to-brand-ink rounded-[2.4rem] shadow-2xl"
                style={{ width, height, padding: Math.round(width * 0.045) }}
            >
                <div className="relative w-full h-full bg-brand-bg rounded-[1.9rem] overflow-hidden flex flex-col">
                    {/* Dynamic Island */}
                    <div className="absolute top-2 left-1/2 -translate-x-1/2 w-14 h-4 bg-brand-ink rounded-full z-20" />

                    <div className="pt-7 px-3.5 pb-2.5 shrink-0">
                        <p className="text-[8px] uppercase tracking-wider text-brand-inkSoft/70 font-semibold truncate">Green Valley Residency</p>
                        <div className="flex items-center justify-between mt-0.5">
                            <h3 className="font-heading font-bold text-sm text-brand-ink">Hi, Mohit</h3>
                            <div className="relative w-6 h-6 rounded-full bg-white border border-brand-line flex items-center justify-center shrink-0">
                                <Bell size={11} weight="fill" className="text-brand-ink" />
                                <span className="absolute -top-0.5 -right-0.5 w-2 h-2 rounded-full bg-brand-action border border-white" />
                            </div>
                        </div>
                    </div>

                    <div className="px-3.5 shrink-0">
                        <div className="bg-brand-ink rounded-xl p-2.5 text-white">
                            <p className="text-[7px] uppercase tracking-wide text-white/60">Outstanding amount</p>
                            <p className="font-heading font-bold text-base mt-0.5 leading-none">&#8377;61,900</p>
                            <button type="button" tabIndex={-1} className="mt-2 w-full bg-brand-action text-white text-[9px] font-semibold rounded-full py-1.5">
                                Pay Maintenance
                            </button>
                        </div>
                    </div>

                    <div className="px-3.5 mt-2.5 grid grid-cols-4 gap-1.5 text-center shrink-0">
                        {QUICK_ACTIONS.map((a) => (
                            <div key={a.label} className="flex flex-col items-center gap-1">
                                <div className="w-7 h-7 rounded-full bg-white border border-brand-line flex items-center justify-center">
                                    <a.icon size={13} weight="duotone" className="text-brand-action" />
                                </div>
                                <span className="text-[6px] text-brand-inkSoft leading-none">{a.label}</span>
                            </div>
                        ))}
                    </div>

                    <div className="px-3.5 mt-2.5">
                        <p className="text-[7px] uppercase tracking-wide text-brand-inkSoft/70 font-semibold mb-1">Notices</p>
                        <div className="bg-white border-l-2 border-brand-action rounded-md px-2 py-1.5">
                            <p className="text-[8px] font-semibold text-brand-ink leading-tight">Society AGM &mdash; 20th Aug, 6 PM</p>
                            <p className="text-[6px] text-brand-inkSoft mt-0.5">Community hall &middot; Governance</p>
                        </div>
                    </div>

                    <div className="mt-auto flex items-center justify-around px-1 py-2 border-t border-brand-line bg-white shrink-0">
                        {TABS.map((t) => (
                            <div key={t.label} className="flex flex-col items-center gap-0.5">
                                <t.icon size={13} weight={t.active ? "fill" : "regular"} className={t.active ? "text-brand-action" : "text-brand-inkSoft/60"} />
                                <span className={`text-[6px] font-medium ${t.active ? "text-brand-action" : "text-brand-inkSoft/60"}`}>{t.label}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
